/* AEVIA — global interactions (vanilla, lightweight) */
(function () {
  'use strict';
  /* expose reveal for dynamically injected content */
  window.AeviaReveal = function(){
    document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function(el){
      if('IntersectionObserver' in window){ var o=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');o.unobserve(e.target);}});},{threshold:.15}); o.observe(el);} else el.classList.add('is-in');
    });
  };


  /* Reveal on scroll */
  const reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* Header scroll state (for transparent hero header) */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile nav */
  const toggle = document.querySelector('[data-nav-toggle]');
  const drawer = document.querySelector('[data-nav-drawer]');
  if (toggle && drawer) {
    const set = (open) => {
      drawer.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    toggle.addEventListener('click', () => set(!drawer.classList.contains('is-open')));
    drawer.addEventListener('click', (e) => { if (e.target.matches('[data-nav-close], a')) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach((q) => {
    const input = q.querySelector('input');
    q.addEventListener('click', (e) => {
      const step = e.target.closest('[data-step]');
      if (!step || !input) return;
      const v = Math.max(1, (parseInt(input.value, 10) || 1) + (step.dataset.step === 'up' ? 1 : -1));
      input.value = v;
    });
  });

  /* PDP thumbnail swap */
  const gallery = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-thumb]').forEach((t) => {
    t.addEventListener('click', () => { if (gallery) { gallery.src = t.dataset.full || t.src; } });
  });
})();
